import { Directive, ElementRef, EventEmitter, Input, OnDestroy, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[cvIntersection]',
  standalone: true,
})
export class IntersectionDirective implements OnDestroy {
  @Input() scrollContainer = null; // add possibility to pass parent element in future
  @Input() showedClass: string = '';
  @Input() intersectedClass: string = '';
  @Output() readonly showed: EventEmitter<void> = new EventEmitter<void>();
  @Output() readonly intersected: EventEmitter<void> = new EventEmitter<void>();
  private observer!: IntersectionObserver;

  constructor(
    private readonly hostElement: ElementRef,
    private readonly render: Renderer2,
  ) {
    this.createObservable();
  }

  ngOnDestroy(): void {
    this.observer.unobserve(this.hostElement.nativeElement as HTMLElement);
  }

  createObservable(): void {
    const options = {
      root: this.scrollContainer,
      rootMargin: '0px',
      threshold: [0, 1],
    };

    this.observer = new IntersectionObserver(this.intersectionHandler.bind(this), options);
    this.observer.observe(this.hostElement.nativeElement as HTMLElement);
  }

  private intersectionHandler(entries: IntersectionObserverEntry[]): void {
    // as for the moment tracking only top intersection
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.boundingClientRect.top < 0) {
        this.render.addClass(this.hostElement.nativeElement, this.intersectedClass);
        this.render.removeClass(this.hostElement.nativeElement, this.showedClass);
        this.intersected.emit();
      }

      if (entry.boundingClientRect.top > 0) {
        this.render.removeClass(this.hostElement.nativeElement, this.intersectedClass);
        this.render.addClass(this.hostElement.nativeElement, this.showedClass);
        this.showed.emit();
      }
    });
  }
}
